<template>
  <model :feature-list="featureList" :page-data="pageData"></model>
</template>

<script>
import model from './model.vue'

export default {
  components: {
    model
  },
  data () {
    return {
      pageData: {
        overview: {
          label: '档案管理能力概览',
          title: '让档案采集、管理与利用在同一套业务体系中有序运行',
          description: '覆盖档案全生命周期的日常办理、权限控制、统计分析与持续配置。',
          tags: ['采集归档', '规范管理', '权限控制', '统计分析'],
          panel: {
            title: '档案管理工作台',
            summaryLabel: '今日待办业务',
            summaryValue: '24 项',
            rows: [
              { label: '采集任务', value: '18 项处理中', tone: 'primary' },
              { label: '整理进度', value: '86%', tone: 'positive' },
              { label: '利用申请', value: '6 项待处理', tone: 'warning' },
              { label: '库房状态', value: '运行正常', tone: 'positive' }
            ],
            footer: '业务办理、权限与统计状态已集中呈现'
          },
          values: [
            { title: '规范可控', description: '统一执行档案标准、权限与业务规则。' },
            { title: '按需配置', description: '适配不同单位的门类、表单和管理要求。' },
            { title: '管理可见', description: '通过报表掌握资源、利用和运行状态。' }
          ]
        },
        featureSection: {
          title: '围绕日常业务，建立一体化管理能力',
          description: '从制度规范到业务办理，再到数据分析，让档案管理工作更加有序、透明和高效。'
        },
        process: {
          title: '让档案管理体系持续发挥价值',
          description: '以统一标准支撑业务运行，并根据管理需求不断优化配置与分析维度。',
          steps: [
            { title: '标准建模', description: '配置分类、元数据、档号与业务规则。' },
            { title: '业务办理', description: '开展采集、整理、保管、利用等日常工作。' },
            { title: '数据分析', description: '通过报表和监控掌握管理状态。' },
            { title: '持续优化', description: '随业务变化调整规则、权限和统计维度。' }
          ]
        }
      },
      featureList: [
        {
          feature: '系统建设规范，权限控制缜密',
          description: [
            '以国家档案建设规范为基础，覆盖档案元数据、档号编制、著录与管理等业务要求。',
            '支持角色、用户与权限自定义，细化控制用户可操作的功能与数据范围。'
          ],
          src2: require('../../assets/images/insert-product-img3.jpg')
        },
        {
          feature: '自定义程度高，构建适用本单位的档案平台',
          description: [
            '可按财会、文书、人事、婚姻、基建工程等不同业务定义档案类型模板。',
            '支持自定义档号构成规则、档案目录与采集表单，适应实际管理流程。'
          ],
          src2: require('../../assets/images/procurement-img-2.jpg')
        },
        {
          feature: '自定义报表设计器，让档案统计不再固化',
          description: [
            '多维度展示档案数量、存储、利用和保管情况，帮助管理人员掌握全局状态。',
            '可结合管理场景配置数据范围、报表访问权限及系统运行监控视图。'
          ],
          src2: require('../../assets/images/procurement-img-3.jpg')
        }
      ]
    }
  }
}
</script>
